<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>
   <smr-stylist-picker
     [stylistID]="stylistID"
     [readOnly]="readOnlyStylistPicker"
     [showAllStaff]="true"
     (onInit)="onStylistPickerInit($event)"
     (stylistSelect)="onStylistSelect($event)"
     cssClass="smr-stylist-picker-for-productivityreport">
   </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar>
   <salonmonster-date-picker
     [startDate]="startDate"
     [endDate]="endDate"
     [disabled]="isLoading"
     (rangeChanged)="rangeChanged($event)"
   ></salonmonster-date-picker>
 </ion-toolbar>
</ion-header>

<ion-content>

  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats" (click)="onTapToReload()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats">

    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" >
        <ion-grid>
          <ion-row>

            <ion-col size="12" size-md="6" class="ion-text-center">

              <div style="height: 50vh;">
                <canvas baseChart
                        [data]="pieChartData"
                        [type]="pieChartType"
                        [options]="pieChartOptions">
                </canvas>
              </div>
              <div padding>
                <p *ngIf="pieChartData[0] >= 85">
                  😄 Aim for about 85% productivity or better.
                </p>
                <p *ngIf="pieChartData[0] < 85">
                  🙁 Room for improvement.
                  <br/>
                  Aim for about 85% productivity or better
                </p>
              </div>
            </ion-col>
            <ion-col size="12" size-md="6" text-center>
              <div  style="height: 50vh;">
                <canvas baseChart
                        #lineChart
                        [data]="lineChartData"
                        [options]="lineChartOptions"
                        [type]="lineChartType">
                </canvas>
              </div>
            </ion-col>
            <ion-col>
              <p-table styleClass="sticky-table" [columns]="cols" [value]="stats" sortMode="multiple" [responsive]="true">
                <ng-template pTemplate="caption">
                  <div class="ui-helper-clearfix" style="text-align: right">
                    <span class="export">Export to:</span>
                    <ion-button
                      fill="outline"
                      (click)="exportExcel()"
                      style="margin-right: 0.5em"
                    >Excel</ion-button>
                    <ion-button
                      fill="outline"
                      (click)="exportPdf()"
                    >
                    PDF
                    </ion-button>
                  </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th [pSortableColumn]="'timestamp'">
                      Date
                      <p-sortIcon [field]="'timestamp'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'booked'">
                      Booked
                      <p-sortIcon [field]="'booked'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'productivity'">
                      <div class="text-align-center">
                      Productivity
                      <p-sortIcon [field]="'productivity'"></p-sortIcon>
                      </div>
                    </th>

                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-stat>

                  <tr>
                    <td>{{stat["timestamp"] }}</td>
                    <td>{{stat["booked"]}} of {{stat["totalWorkingHours"]}} hours</td>
                    <td class="center-numbers-table-x_wider-padding">{{stat["productivity"]}}%</td>
                  </tr>

                </ng-template>
              </p-table>

            </ion-col>

          </ion-row>

        </ion-grid>

      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>



  </ng-container>

</ion-content>
